<!-- 示例页面 -->
<template>
  <div class="order-pages">
    <div class="">
      <div class="pb16">订单管理</div>
      <div class="mains-content">
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row space-between">
              <div class="flex-row">
                <el-select v-model="query.orderStatus" class="select" placeholder="消费项目">
                  <el-option label="全部类型" value></el-option>
                  <el-option label="待付款" value="waitPay"></el-option>
                  <!-- <el-option label="待消费" value="waitConsume"></el-option>
                  <el-option label="待取货" value="waitExtract"></el-option> -->
                  <el-option label="已完成" value="finish"></el-option>
                  <el-option label="已取消" value="cancel"></el-option>
                  <el-option label="已作废" value="invalid"></el-option>
                </el-select>
              </div>
              <div class="flex-row ml10">
                <el-select v-model="query.staffId" class="select" placeholder="服务技师">
                  <el-option label="全部技师" value></el-option>
                  <el-option v-for="(item, index) in staffList" :key="index" :label="item.staffName"
                    :value="item.id"></el-option>
                </el-select>
              </div>

            </div>
            <div class="flex-row ml10">
              <v-date @time="changeDate"></v-date>
            </div>
            <el-input placeholder="手机号/身份证号" v-model="query.customerName" clearable @clear="removeDoQuery"
              class="w200 ml10 mr10"></el-input>
            <el-button type="primary" @click="searchDoQuery">搜索</el-button>
          </div>
          <div class="m16 white" v-perm="{ key: 'orderInfo', value: 'orderInfo:list' }">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor"
              empty-text="暂无数据，重新筛选交易时间试试">
              <el-table-column :prop="index" :align="item.align" :label="item.label" :width="item.width"
                :min-width="item.minWidth" :show-overflow-tooltip="false" v-for="(item, index) in columns" :key="index">
                <template slot-scope="scope">
                  <div v-if="index == 'customerName'">{{ scope.row.customerName }}&nbsp;{{ scope.row.mobile }}</div>
                  <div v-else>{{ Boolean(item.formatDay) ? formatDate(scope.row[index]) : scope.row[index] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="170" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" v-perm="{ key: 'orderInfo', value: 'orderInfo:detail' }"
                    @click="handleClick(scope.row)">订单信息</el-link>&nbsp;
                  <el-link type="primary" @click="queryPayResult(scope.row)" v-if="(scope.row.payWay == 'yinlianStore' || scope.row.payWay == 'tonglianStore') && scope.row.orderStatus == 'processing'" :disabled="loadingFlag">查询支付结果</el-link>  
                  <!-- <el-link
                    type="primary"
                    v-if="scope.row.orderType == 'repair'"
                    class="ml10"
                    @click="updateDeduct(scope.row)"
                  >提成信息</el-link>-->
                  <!-- <el-button type="primary" @click="handleClick(item,index)">操作详情</el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>

    </div>
    <edit-set ref="editForm" @change="refreshPage"></edit-set>
    <deduct-set ref="deductForm" @change="deductPage"></deduct-set>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import config from "./config/columns";
import editSet from "./edit";
import deductSet from "./deductSet";
export default {
  mixins: [minxin],
  components: { editSet, deductSet },
  data() {
    return {
      list: [],
      height: this.$store.getters.MainHeight,
      url: this.$url.orderInfo.listByTime,
      columns: config.columns,
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        customerName: "",
        memberId: "",
        staffId: "",
        mobile: "",
        orderStatus: "",
        payStatus: "",
        serveStatus: "",

      },
      staffList: [],
      loadingFlag: false,
    };
  },
  created() {
    if (this.$route.params.item != undefined) {
      //入口 会员管理-待取货
      let arr = this.$route.params.item;
      this.query.customerName = arr.customerName;
      this.query.orderStatus = arr.orderStatus;
    }
    this.getStaffList();
    this.totalCounts();
  },
  destroyed() {
    localStorage.removeItem("payMobile")
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("payMobile"))) {
      let arr = JSON.parse(localStorage.getItem("payMobile"));
      if (arr.path == this.$route.path) {
        this.$refs["editForm"].$emit("set", arr.id);
      }
    }
    if (this.$route.params.id) {
      this.$refs["editForm"].$emit("set", this.$route.params.id);
    }
  },
  methods: {
    queryPayResult (row) {
      if (this.loadingFlag) return;
      this.loadingFlag = true;
      this.$api.get(this.$url.orderInfo.getBSCPayStatus, {
        orderId: row.id,
        payWay: row.payWay,
      }).then(res => {
        this.loadingFlag = false;
        if (res && res.payStatus) { 
          if (res.payStatus == 'finish') { 
            this.totalCounts();
          } else if (res.payStatus == 'processing') {
            this.$notify.warning({
              title: '提示',
              message: '订单正在处理中，请稍后查询'
            });
          }
        }
      }).catch(error => {});
    },
    searchDoQuery() {
      //不能跨年查询
      let beginDate = this.getDate(this.query.beginTime);
      let endDate = this.getDate(this.query.endTime);
      if (beginDate.getFullYear() != endDate.getFullYear()) {
        this.$notify.error({
          title: '错误',
          message: '不能跨年查询'
        });
        return;
      }
      this.query.start = 1
      this.totalCounts();
    },
    getDate(strDate) {
      var regEx = new RegExp("\\-", "gi");
      strDate = strDate.replace(regEx, "/");
      var milliseconds = Date.parse(strDate);

      var date = new Date();
      date.setTime(milliseconds);
      return date;
    },
    getStaffList() {
      this.$api
        .get(this.$url.companyStaff.list, { filterStatus: 'disable' })
        .then(res => {
          if (res) {
            this.staffList = res;
          }
        })
        .catch(error => { });
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    removeDoQuery() {
      this.query.customerName = "";
    },
    handleClick(item, index) {
      this.$refs["editForm"].$emit("set", item.id);
    },
    updateDeduct(item) {
      this.$refs["deductForm"].$emit("set", item.id);
    },
    refreshPage(org) {
      if (org) {
        this.getData();
      }
    },
    totalCounts() {
      this.$api.post(this.$url.orderInfo.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    deductPage(org) {
      if (org) {
        this.getData();
      }
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/edit.less";

.page-head {
  position: relative;

}

.order-pages {
  position: relative;
  padding: 16px 16px 0;
}

.mains-content {
  background-color: #fff;
  border-radius: 10px;

  .member-header {
    background: #fff;
    padding: 16px 16px 0;
    display: flex;
    align-items: center;
    border-radius: 10px;

    .top-label {
      width: 90px;
    }
  }
}
</style>